import * as types from './mutation-types'

const state = () => ({
  openedModalNames: new Set()
})

const getters = {
  isModalVisibleByName: state => modalName =>
    !!state.openedModalNames.has(modalName)
}

const actions = {
  setModalToOpenState({ commit, getters }, modalName) {
    if (getters.isModalVisibleByName(modalName)) return

    commit(types.ADD_MODAL_NAME_TO_OPENED, modalName)
  },
  setModalToCloseState({ commit }, modalName) {
    if (!getters.isModalVisibleByName(modalName)) return

    commit(types.REMOVE_MODAL_NAME_FROM_OPENED, modalName)
  }
}

const mutations = {
  [types.ADD_MODAL_NAME_TO_OPENED](state, modalName) {
    state.openedModalNames.add(modalName)
  },
  [types.REMOVE_MODAL_NAME_FROM_OPENED](state, modalName) {
    state.openedModalNames.delete(modalName)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
